import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Button } from '../common/Button';
import { Card } from '../common/Card';

export const SignupForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        confirmPassword: '',
    });
    const [passwordError, setPasswordError] = useState('');
    const { signup, isLoading, error, clearError, user } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        console.log("Entered handleSubmit function")
        e.preventDefault();
        setPasswordError('');

        if (formData.password !== formData.confirmPassword) {
            setPasswordError('Passwords do not match');
            return;
        }

        try {
            await signup(
                formData.email,
                formData.password,
                formData.name,
                user?.is_anonymous || false
            );

            navigate('/login', {
                replace: true,
                state: {
                    message: 'Account created successfully! Please check your email for verification link.',
                    type: 'success'
                }
            });
        } catch (err) {
            console.error('Signup failed:', err);
        }
    };

    return (
        <Card className="max-w-md mx-auto p-8">
            <h2 className="text-2xl font-bold text-center mb-6">
                {user?.is_anonymous ? 'Create Your Account' : 'Create an Account'}
            </h2>
            {error && (
                <div className="bg-red-50 text-red-500 p-3 rounded mb-4">
                    {error}
                </div>
            )}
            {passwordError && (
                <div className="bg-red-50 text-red-500 p-3 rounded mb-4">
                    {passwordError}
                </div>
            )}
            {user?.is_anonymous && (
                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                    <div className="flex">
                        <div className="ml-3">
                            <p className="text-sm text-yellow-700">
                                Creating an account will preserve all your existing data.
                            </p>
                        </div>
                    </div>
                </div>
            )}
            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                        Full Name
                    </label>
                    <div className="mt-1">
                        <input
                            id="name"
                            name="name"
                            type="text"
                            required
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                </div>
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                        Email
                    </label>
                    <input
                        id="email"
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                        Password
                    </label>
                    <input
                        id="password"
                        type="password"
                        value={formData.password}
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1">
                        Confirm Password
                    </label>
                    <input
                        id="confirmPassword"
                        type="password"
                        value={formData.confirmPassword}
                        onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        required
                    />
                </div>
                <Button
                    type="submit"
                    className="w-full"
                    disabled={isLoading}
                >
                    {isLoading ? 'Creating Account...' : (user?.is_anonymous ? 'Convert to Full Account' : 'Sign Up')}
                </Button>
            </form>
        </Card>
    );
}; 